<template>
  <component class="columns" :is="tag">
    <slot />
  </component>
</template>

<script>
export default {
  name: "AColumns",
  props: {
    tag: {
      default: "div",
      required: false,
      type: String
    }
  }
};
</script>

<style lang="scss">
@import "~bulma/sass/grid/columns.sass";
</style>
